import type { IconNames } from '../Icon/generated/utils.js';
import { Icon } from '../Icon/Icon.js';
import type { BannerTypes } from './Banner.types.js';
import { useBanner } from './BannerContext.js';

const BannerIcon = () => {
  const { variant } = useBanner();

  const map: Record<BannerTypes, IconNames> = {
    default: 'smile',
    info: 'info',
    success: 'check',
    warning: 'warning',
    error: 'error',
  };

  return <Icon name={map[variant]} />;
};

export { BannerIcon };
